import React from 'react'
import { ReflectionFullInfoQueryResult } from '@graphql/queries/__generated__/reflection.generated'
import { ProductVariantFullInfoQueryResult } from '@graphql/queries/__generated__/product-variant.generated'
import { AddedProductVariantFragment } from '@graphql/fragments/__generated__/AddedProductVariant.generated'
import { SupplyLinesJson } from '../types'
import { UserFragment } from '@graphql/fragments/__generated__/User.generated'

function noop() {}

export interface IProductContext {
  selectedVariant: ProductVariantFullInfoQueryResult['data']['productVariant'] | null

  onChangeSelectedVariant(attrs): Promise<void>

  reflection: ReflectionFullInfoQueryResult['data']['reflectionDetails']['reflection']
  formValues: {
    quantity: number
    selectedAttrs: {
      [key: string]: string
    }
  }
  formMethods: {
    onChangeQuantity: any
    setSelectedAttrs: any
  }
  // pickerDataJson: any
  // selectedValues: {}
  loading: boolean
  me: UserFragment | null
  images: {
    id: string
    alt: string
    url: string
    thumbnail: string
    width: number
    height: number
  }[]
  attributes: {
    name: string
    values: string[]
  }[]
  lastAddedVariantInfo: {
    variant: AddedProductVariantFragment
    quantity: number
    cartLine: {
      id: string
      pk: number
    }
    product: {
      id: string
      pk: number
    }
    supplyLinesJson?: SupplyLinesJson
  }

  matchVariantFromSelection: any
  onAddToBag: any
  onAddToBagFullKit: any
  onCustomizeKit?: any
  isModal?: boolean

  setLastAddedVariantInfo(v): void

  onDownloadFiles(url: string): void
  setIsOpenProductDialog?({}: { pk: number; slug: string }): void
}

const ProductContext = React.createContext<IProductContext>({
  selectedVariant: null,
  reflection: null,
  formValues: {
    quantity: 1,
    selectedAttrs: null,
  },
  formMethods: {
    onChangeQuantity: (qty: number) => {},
    setSelectedAttrs: (attrs: any) => {},
  },
  loading: false,
  me: null,
  attributes: [],
  images: [],
  lastAddedVariantInfo: null,
  isModal: false,

  matchVariantFromSelection: noop,
  onAddToBag: noop,
  onAddToBagFullKit: noop,
  onCustomizeKit: noop,

  setLastAddedVariantInfo: noop,
  onDownloadFiles: url => {},
  onChangeSelectedVariant: async attrs => {},
  setIsOpenProductDialog: values => null,
})
export default ProductContext
